import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=552a9430&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=552a9430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a9430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552a9430')) {
      api.createRecord('552a9430', component.options)
    } else {
      api.reload('552a9430', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=552a9430&scoped=true&", function () {
      api.rerender('552a9430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/knowledge/Form.vue"
export default component.exports